import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { isEmpty, isNull } from 'lodash-es';

import { CampaignTriggerType, CampaignType } from '@dev/ee-api/ee-api-models';
import { SimpleToggle, Typography } from '@dev/ee-components';

import { AutoresponderToggleProps } from '@/components/CampaignCreator/SettingsAndTracking/SettingsAndTrackingInterface';
import { useGetAutomatedInfo } from '@/components/CampaignCreator/SettingsAndTracking/hooks/useGetAutomatedInfo';
import { useCampaignScreensPathsChecker } from '@/components/CampaignCreator/hooks/useCampaignScreensPathsChecker';
import { getCampainCreatorStore, ModifyCampaignMap } from '@/store/campaignCreator/actions';
import { ToggleWrapper } from '../../../../../../../styled';

export const AutoresponderToggle = (props: AutoresponderToggleProps): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isDetailsScreen } = useCampaignScreensPathsChecker();

    const { campaign } = useSelector(getCampainCreatorStore);
    const isAllContacts = !isEmpty(campaign?.Targets?.SegmentNames.filter((value) => value === 'All contacts'));
    const { triggerType } = useGetAutomatedInfo();

    const handleToggleChange = (ev) => {
        const toggleChecked = ev.target.checked;
        props.setAutoresponderChecked(toggleChecked);

        const modifyMap = new Map<string, any>();
        const hasDateToSendOn = !isNull(campaign?.TriggerOptions?.DateToSendOn);
        const triggerOptionsType = hasDateToSendOn ? CampaignTriggerType.FutureScheduled : CampaignTriggerType.SendNow;
        modifyMap.set('Type', toggleChecked ? CampaignType.Automated : CampaignType.SendNow);
        modifyMap.set('TriggerOptions.Type', toggleChecked ? triggerType : triggerOptionsType);
        dispatch(ModifyCampaignMap(modifyMap));
    };

    return (
        <ToggleWrapper>
            <SimpleToggle
                id="autoresponder-toggle"
                value="autoresponderOptions"
                checked={props.autoresponderChecked}
                onChange={handleToggleChange}
                disabled={!(isEmpty(campaign?.Targets?.SegmentNames) || isAllContacts) || isDetailsScreen}
            />
            <Typography variant="h3">{t('autoresponderoptions')}</Typography>
        </ToggleWrapper>
    );
};
